import { Themed, THEMES } from "@components/atoms/Themed"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { usePageContext } from "../contexts/PageContext"
import { useEffect } from "react"

export default defineView("single-case-study", (props) => {
  return (
    <Themed
      page
      theme={props.caseStudy?.pageTheme}
      footer
      footerTheme={props.caseStudy?.footerTheme}
      className="w-full"
    >
      <ContentBlocks blocks={props.caseStudy?.contentBlocks} />
    </Themed>
  )
})
